import type { ApiResponseState } from './types'

export function parseResponse<R>(response: ApiResponseState<R>): ApiResponseState<R> {
  return response
}
